import axios from 'axios';
import store from '../store';

// axios.interceptors.response.use(
//   function(response) { return response; },
//   function(error) {
//       if (error.response) {
//         console.log(error.response);
//         store.commit('showNotification', { text: error.response.data.error, status: 'error' });
//         return Promise.reject(error);
//       }
//   });

// const baseUrl = 'http://192.168.1.8:3000';
const baseUrl = process.env.VUE_APP_ROOT_API;

const state = {
  tiposSituacao: []
};

const getters = {
  // Tipos Situação
  tiposSituacao: state => state.tiposSituacao.sort((a, b) => a.Descricao > b.Descricao ? 1 : -1),
  tiposSituacaoAtivo: state => state.tiposSituacao.filter(t => t.Status.startsWith('A')).sort((a, b) => a.Descricao > b.Descricao ? 1 : -1),
}

const actions = {
  // Tipos Situações
  async fetchTiposSituacao({ commit }) {
    const response = await axios.get(`${baseUrl}/tipossituacoes`);
    if (response.data) {
      commit('setTiposSituacao', response.data);
    } else {
      commit('setTiposSituacao', []);
    }
  },
  async fetchTiposSituacaoSql({ commit }, args) {
    try {
      const response = await axios.get(`${baseUrl}/tipossituacoes?idLayoutSql=${args.idLayoutSql}`);
      if (response.data.length) {
        commit('setTiposSituacao', response.data);
      } else {
        commit('setTiposSituacao', []);
      }
    } catch (error) {
      commit('setTiposSituacao', []);
    }
  },
  async addTipoSituacao({ commit }, tipoSituacao) {
    const response = await axios.post(`${baseUrl}/tipossituacoes`, tipoSituacao, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    tipoSituacao.IdTipoSituacao = response.data.IdTipoSituacao;
    commit('newTipoSituacao', tipoSituacao);
    return response.data.IdTipoSituacao;
  },
  async updateTipoSituacao({ commit }, updTipoSituacao) {
    await axios.put(`${baseUrl}/tipossituacoes`, updTipoSituacao, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    commit('updateTipoSituacao', updTipoSituacao);
  },
  async deleteTipoSituacao({ commit }, id) {
    await axios.delete(`${baseUrl}/tipossituacoes/${id}`, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    commit('removeTipoSituacao', id);
  },
}

const mutations = {
  // Tipos Situacao
  setTiposSituacao: (state, tiposSituacao) => state.tiposSituacao = tiposSituacao,
  newTipoSituacao: (state, tipoSituacao) => state.tiposSituacao.push(tipoSituacao),
  removeTipoSituacao: (state, id) => state.tiposSituacao = state.tiposSituacao.filter(tipoSituacao => tipoSituacao.IdTipoSituacao !== id),
  updateTipoSituacao: (state, updTipoSituacao) => {
    const index = state.tiposSituacao.findIndex(tipoSituacao => tipoSituacao.IdTipoSituacao === updTipoSituacao.IdTipoSituacao);
    if (index !== -1) {
      state.tiposSituacao.splice(index, 1, updTipoSituacao);
    }
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}